import React, { useMemo } from "react";
import styled from "styled-components";
import { useMediaQuery } from "react-responsive";
import i18next from "i18next";
import { slide as Menu } from "react-burger-menu";

import ARLogo from "../../assets/images/logo/logoAR_Dark.svg";
import ENLogo from "../../assets/images/logo/logoEN_Dark.svg";
import NavItems from "./NavItems";

import { menuStyles } from "./menuStyles";
import UserTools from "./UserTools";
import { Icon } from "../styles/Design";
import LanguagesMenu from "./LanguagesMenu";
import SearchIcon from "../../assets/icons/Search_alt.svg";

const { language, dir } = i18next;

const NavbbarContainer = styled.div`
  width: 100%;
  height: 8vh;
  background-color: ${({ theme }) => theme.colors.navbarBackgroundColor};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 135px;
  @media (max-width: 768px) {
    padding: 0 16px;
  }
`;

const LogoContainer = styled.div`
  width: 143px;
  height: 42px;
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

const Navbar = () => {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const languageDirection = useMemo(() => {
    if (dir === "rtl") {
      return false;
    }
    return true;
  }, []);
  console.log(languageDirection);
  return (
    <NavbbarContainer>
      <LogoContainer>
        <img src={language === "ar" ? ARLogo : ENLogo} alt="logo" />
      </LogoContainer>

      {isMobile ? (
        <>
          <Menu right={languageDirection} styles={menuStyles}>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <Icon src={SearchIcon} alt={"search"} />
              <LanguagesMenu />
            </div>
            <NavItems direction="column" />
            <UserTools />
          </Menu>
        </>
      ) : (
        <>
          <NavItems />
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Icon src={SearchIcon} alt={"search"} />
            <LanguagesMenu />
          </div>
          <UserTools />
        </>
      )}
    </NavbbarContainer>
  );
};

export default Navbar;
